/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Brew_Water_TempInputs */

const vi_shop_brew_water_temp = /** @type {(inputs: Shop_Brew_Water_TempInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiệt độ nước`)
};

/**

* @param {Shop_Brew_Water_TempInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_brew_water_temp = /** @type {((inputs?: Shop_Brew_Water_TempInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Brew_Water_TempInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_brew_water_temp(inputs)
});